package org.matthewo.styles

import js.reflect.unsafeCast
import web.cssom.Color
import kotlin.math.roundToInt

fun Color.lighten(scale: Double): Color {
    val rgb = toRGBOrNull() ?: return this
    val lighter = RGB(rgb.r.toDouble() * scale, rgb.g.toDouble() * scale, rgb.b.toDouble() * scale)
    return lighter.toColor()
}

fun Color.darken(scale: Double) = lighten(1 / scale)

private data class RGB(val r: UByte, val g: UByte, val b: UByte) {
    constructor(r: Double, g: Double, b: Double) : this(r.toChannel(), g.toChannel(), b.toChannel())

    fun toColor() = Color("#${r.toString(16)}${g.toString(16)}${b.toString(16)}")
}

private fun Color.toRGBOrNull(): RGB? {
    val color = unsafeCast<String>(this)
    if (color.startsWith("#")) {
        val channels = color.drop(1)
        when (channels.length) {
            3 -> return RGB(channels.parseChannel(0), channels.parseChannel(1), channels.parseChannel(2))
            6 -> return RGB(channels.parseChannel(0, 2), channels.parseChannel(2, 4), channels.parseChannel(4, 6))
        }
    }
    return null
}

private fun String.parseChannel(start: Int, end: Int? = null): UByte {
    val channel =
        if (null == end) substring(start, start + 1) + substring(start, start + 1)
        else substring(start, end)
    return channel.toUByte(16)
}

private fun Double.toChannel() = roundToInt().coerceIn(0, 255).toUByte()
